import React from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import {Typography} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";

const OPTION_INSTRUMENTS = ["option", "future_option"];
const INSTRUMENT_OPTIONS = [
    { value: "stock", label: "stock" },
    { value: "option", label: "option" },
    { value: "future", label: "future" },
    { value: "future_option", label: "future option" },
    { value: "crypto", label: "crypto" },
    { value: "forex", label: "forex" },
];

export default function InstrumentRadios({top, dispatchTop, setViewOptionManagementEnabled}) {
    return (
        <Grid container>
            <RadioGroup
                row
                aria-label="instrument"
                name="instrument"
                value={top.instrument}
                onChange={(ev) => {
                    dispatchTop({ instrument: ev.target.value });
                     setViewOptionManagementEnabled(OPTION_INSTRUMENTS.includes(ev.target.value));
                     /*if (ev.target.value === "stock") {
                         if (symbolsUsed !== 1) {
                             setSymbolsUsed(1);
                         }
                     }
                     let isOption = ev.target.value === "option";
                     let isQty = top.quantityBasis === "QUANTITY";
                     let qtyBasisValue = 0;
                     if (props.defaultQtyBasis !== undefined) {
                         if (isOption) {
                             if (isQty) {
                                 qtyBasisValue = props.defaultQtyBasis["qtyOption"];
                             } else {
                                 qtyBasisValue = props.defaultQtyBasis["dollarOption"];
                             }
                         } else {
                             if (isQty) {
                                 qtyBasisValue = props.defaultQtyBasis["qtyStock"];
                             } else {
                                 qtyBasisValue = props.defaultQtyBasis["dollarStock"];
                             }
                         }
                         props.dispatchMarketOrder({
                             quantityBasisValue: qtyBasisValue,
                         });
                         props.dispatchLimitOrder({
                             quantityBasisValue: qtyBasisValue,
                         });
                         props.dispatchCandleBreak({
                             quantityBasisValue: qtyBasisValue,
                         });
                     }*/
                }}
            >
                {INSTRUMENT_OPTIONS.map(({ value, label }) => (
                    <Grid item xs={4} key={value}>
                        <FormControlLabel
                            value={value}
                            control={<StyledRadio/>}
                            label={
                                <Typography style={{fontSize: 10}}>{label}</Typography>
                            }
                            labelPlacement={"bottom"}
                        />
                    </Grid>
                ))}
            </RadioGroup>
        </Grid>
    )
}
